/* Khuttwa glass-tab product card: the + opens the sizes inside the card, picking a size adds it to the cart */
(function () {
  if (window.__khrCard) return;
  window.__khrCard = true;

  function closeAll(except) {
    document.querySelectorAll('.khr-card.is-open').forEach(function (c) {
      if (c === except) return;
      c.classList.remove('is-open');
      var b = c.querySelector('[data-khr-toggle]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var toggle = e.target.closest('[data-khr-toggle]');
    if (toggle) {
      e.preventDefault();
      var card = toggle.closest('.khr-card');
      if (!card) return;
      var open = !card.classList.contains('is-open');
      closeAll(card);
      card.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    var chip = e.target.closest('[data-khr-variant]');
    if (chip) {
      e.preventDefault();
      if (chip.disabled) return;
      var c = chip.closest('.khr-card');
      var form = c && c.querySelector('.khr-form form');
      if (!form) return;
      var id = form.querySelector('[name="id"]');
      var btn = form.querySelector('[type="submit"]');
      var plus = c.querySelector('[data-khr-toggle]');
      id.disabled = false;
      id.value = chip.getAttribute('data-khr-variant');
      chip.classList.add('is-picked');
      if (plus) plus.classList.add('is-loading');
      if (btn) btn.removeAttribute('aria-disabled');
      if (form.requestSubmit) form.requestSubmit(btn);
      else if (btn) btn.click();
      setTimeout(function () {
        chip.classList.remove('is-picked');
        if (plus) {
          plus.classList.remove('is-loading');
          plus.setAttribute('aria-expanded', 'false');
        }
        c.classList.remove('is-open');
      }, 1100);
      return;
    }

    if (!e.target.closest('.khr-card')) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });
})();
